import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import {Control} from "react-redux-form";
import { getQuestion, submitAnswer, downloadFile, getDownloadTime } from "../reducers/questions";
import {Link} from "react-router-dom";
import {zeroPad} from 'react-countdown';
import SanitizeHTML from 'react-sanitized-html'
import ReactStopwatch from 'react-stopwatch';
import Loading from "../components/loading";

class Stopwatch extends Component {
	componentDidMount() {
		this.props.getDownloadTime()
	}

	duration(t0, t1){
		let d = (new Date()) - (new Date());
		let weekdays     = Math.floor(d/1000/60/60/24/7);
		let days         = Math.floor(d/1000/60/60/24 - weekdays*7);
		let hours        = Math.floor(d/1000/60/60    - weekdays*7*24            - days*24);
		let minutes      = Math.floor(d/1000/60       - weekdays*7*24*60         - days*24*60         - hours*60);
		let seconds      = Math.floor(d/1000          - weekdays*7*24*60*60      - days*24*60*60      - hours*60*60      - minutes*60);
		let milliseconds = Math.floor(d               - weekdays*7*24*60*60*1000 - days*24*60*60*1000 - hours*60*60*1000 - minutes*60*1000 - seconds*1000);
		let t = {};
		['weekdays', 'days', 'hours', 'minutes', 'seconds', 'milliseconds'].forEach(q=>{ if (eval(q)>0) { t[q] = eval(q); } });
		return t;
	}

	render(){
		// if(!this.props.questions.currentQuestion.downloadTime)
		// 	return null

		return (
			<ReactStopwatch
				seconds={0}
				minutes={0}
				hours={0}
				render={({ formatted, hours, minutes, seconds }) => {
					return (
						<div className="timer">
							<div className="box-shadow">
								<p>time since download</p>
								<ul>
									<li><span id="hours">{zeroPad(hours)}</span>Hours</li>
									<li className="timer-after">:</li>
									<li><span id="minutes">{zeroPad(minutes)}</span>Minutes</li>
									<li className="timer-after">:</li>
									<li><span id="seconds">{zeroPad(seconds)}</span>Seconds</li>
								</ul>
							</div>
						</div>
					);
				}}
			/>
		)
	}
}

class Example extends Component {
	componentWillMount() {
		window.scrollTo(0,0);
		this.props.getQuestion(1);
	}

	render() {
		if(!this.props.questions.currentQuestion || !this.props.questions.currentQuestion.Answers)
			return <Loading {...this.props} />

		let breadClass = '';
		if(this.props.questions.currentQuestion.Difficulty.Title === 'Medium'){
			breadClass = 'm';
		}
		else if(this.props.questions.currentQuestion.Difficulty.Title === 'Advanced') {
			breadClass = 'h';
		}

		return (
			<main className="">
				<section className="bread-crumbs bg-color_gradient paddingLeft-120">
					<ul className="d-flex">
						<li>
							<Link to={'/'}>All Challenges</Link>
						</li>
						<li className={'active_' + breadClass}>
							<Link to={'/'}>{this.props.questions.currentQuestion.Difficulty.Title}</Link>
						</li>
						<li>{this.props.questions.currentQuestion.Title}</li>
					</ul>
				</section>

				<section className="content bg-color_gradient paddingLeft-150 shadow-top">
					<div className="row">
						<div className="col-12">
							<h3 className="blue-text bold mb-5">{this.props.questions.currentQuestion.Title}</h3>
						</div>

						<div className="col-12 col-lg-6">
							<div className="text">
								<h3 className="white-text">Story</h3>
								<SanitizeHTML html={this.props.questions.currentQuestion.Content}/>
							</div>
							<div className="download">
								<div className="title">Download Files</div>
								<div className="download__block">

									{this.props.questions.currentQuestion.Downloads && this.props.questions.currentQuestion.Downloads.map((item, key) => {
										return (
											<div key={key} className="download__down">
												<button onClick={() => this.props.downloadFile(item.Id)} className="item">
													<p>Download File</p>

													<img src={require("../img/arrow-bottom.png")} alt="" />
												</button>
											</div>
										)
									})}
								</div>
							</div>
						</div>

						<div className="col-12 col-lg-6">
							<div className="instruct">
								<div className="title">Instructions</div>
								<div className="text">
									<SanitizeHTML html={this.props.questions.currentQuestion.Instructions}/>
								</div>
								<div className="form-style">
									<Stopwatch {...this.props} />

									<form>
										{this.props.questions.currentQuestion.Answers.map((answer, key) => {
											return (
												<div key={key} className="position-relative input-effect">
													<Control.text disabled model={'.Answers['+key+'].GivenAnswer'} className="effect" />
													<label>{answer.Label}</label>
												</div>
											)
										})}

										<input disabled type="submit" className="submit bold btn-hover" value="SUBMIT" />
									</form>
								</div>
							</div>
						</div>

					</div>
				</section>
			</main>
		);
	}
}

function mapStateToProps(state) {
	return {questions: state.questions};
}

const mapDispatchToProps = dispatch => bindActionCreators({
	getQuestion,
	submitAnswer,
	downloadFile,
	getDownloadTime
}, dispatch)

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Example);